<template>
  <el-container>
              <!-- 头部 -->
        <div class="indeherader">
           <el-header class="flex nsherader">  
               <teacherHeader />
           </el-header>
        </div>
        <div class="isSilderMenu"  @click="openBz">
           <el-tooltip class="item" effect="dark" content="帮助文档" placement="left">
           <span class="icon-al-question-circle"></span>   
          </el-tooltip>
     
          </div>
        <!-- 侧边菜单 -->
        <div class="sidebar">
             <teacherSidebar />
        </div>
       <el-main class="indemain">
            <transition name="slide">
              <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view> 
          </keep-alive>
            </transition>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </el-main>
           <!-- 底部 -->
        <div class="indefooter">
             <el-footer><ns-footer /></el-footer>
        </div>
         </el-container>
</template> 
<script>
import teacherHeader from "./components/teacherHeader.vue"
import NsFooter from "./components/NsFooter"
import teacherSidebar from "./components/teacherSidebar.vue"
import { dowloadDetail} from "@/api/enterprise/index" // 下载详情、线索、
export default {
      name: "Layout",
    inject: ["reload"],
     components: {
        teacherHeader,
        NsFooter,
        teacherSidebar
     },
     data() {
      return {
        appId:'',
      }
     },
     created() {
      this.appId = this.$locaStorage.setAge().get('tearchHelpId')
     },
     methods: {
       // 打开对应帮助文档
            openBz(){
                dowloadDetail({
                id:this.appId,
            },'enterprise')
            .then(res => {
              if(res.data){
                const newurl = this.$router.resolve({name: 'enhelpdetail', query: {id: res.data.supportId,type:1}})
                window.open(newurl.href,'_blank')
              }else{
                this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
              }
            })
            .catch(err => {
                this.$util.Notifi(err.msg,'error','fa-exclamation-circle');
            })
                
            },
     }
}
</script>
<style lang="scss" scoped>
.isSilderMenu{
    position: fixed;
        bottom: 10%;
        right: 40px;
        z-index: 200;
        cursor: pointer;
      span{
          font-size:  30px
      }
}
.indeherader{
    height: 56px;
    position: fixed;
    left: 210px;
    top: 0;
    background-color: #fff;
    border-bottom: 1px solid rgb(235, 237, 240);
    width: 100%;
    .nsherader{
        width: 100%;
        margin: 0 auto;
        height: inherit !important;
    }
}
.sidebar{
    width: 210px;
    background: #fff;
    height:100%;
    position: fixed;
    left: 0;
    top: 0px;
    background: #304156;
    box-sizing: border-box;

}

.indemain{
    width: calc(100% - 210px);
    height: calc(100vh - 120px);
    position: fixed;
    left: 210px;
    top: 57px;
    overflow: auto;
    background: rgb(245, 246, 250);
}
.indefooter{
  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.08);
    background: #FFF;
    height: 60px;
    position: fixed;
    left: 210px;
    bottom: 0px;
    width: calc(100% - 210px);
}
</style>